var _defs, _path, _path2, _g, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecorderroricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Record_error_icon",
    "data-name": "Record error icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137.949,
    height: 128.736,
    viewBox: "0 0 137.949 128.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_6806",
    x: 18.173,
    y: 22.83,
    width: 119.776,
    height: 105.906,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40609",
    "data-name": "Path 40609",
    d: "M70.364,34.912A25.043,25.043,0,1,1,45.32,9.869,25.046,25.046,0,0,1,70.364,34.912",
    transform: "translate(4.969 -9.869)",
    fill: "#3c3c3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40610",
    "data-name": "Path 40610",
    d: "M82.923,20.944a29.871,29.871,0,0,1-35.181,0c-14.91,6.669-26.8,21.564-32.305,40.436-1.51,5.182,1.549,10.693,5.872,10.693h88.076c4.328,0,7.392-5.511,5.872-10.693-5.51-18.872-17.4-33.782-32.315-40.436",
    transform: "translate(-15.045 32.497)",
    fill: "#3c3c3b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_6806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6806-2",
    "data-name": "Path 6806",
    d: "M53.906,1.732l47.386,80.911a3.5,3.5,0,0,1-3.018,5.265H3.5A3.5,3.5,0,0,1,.485,82.643L47.871,1.732a3.5,3.5,0,0,1,6.036,0",
    transform: "translate(27.17 28.83)",
    fill: "#eed202"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6807",
    "data-name": "Path 6807",
    d: "M552.642,668.377a3.81,3.81,0,1,1-3.81-3.81,3.81,3.81,0,0,1,3.81,3.81",
    transform: "translate(-470.889 -572.5)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    "data-name": "Path 6808",
    d: "M528.5,309.346h-.056a2.538,2.538,0,0,1-2.52-2.237L522.8,280.957a2.538,2.538,0,0,1,2.52-2.838h6.369a2.538,2.538,0,0,1,2.519,2.845l-3.191,26.152a2.537,2.537,0,0,1-2.519,2.23",
    transform: "translate(-450.569 -219.349)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorderroricon);
export default __webpack_public_path__ + "static/media/Record error icon.96c3fe19a3f289b60b532b38872218a5.svg";
export { ForwardRef as ReactComponent };